<template>
  <div>
    <div class="flex justify-between items-start mb-4" :class="{error: invalidDate}">
      <label class="text-sm w-1/3 m-0 text-left mr-2 mt-2">Collection date 

      </label>
      <div class="flex-1">
        <datepicker v-model="order.date" :disabled-dates="disabledDates" @selected="dirty.date = true" input-class="input text-left" />
        <div v-if="invalidDate" class="mt-2 text-sm text-jpink">
          <p v-if="hasCake">Sorry - this date is no longer available for cakes</p>
          <p v-else>Sorry - this date is no longer available</p>
        </div>  
        <p v-else class="text-xs mt-1">
         You can pick them up between <strong class="whitespace-no-wrap" v-if="christmasEve">10.30am - 1pm</strong><strong class="whitespace-no-wrap" v-else-if="thursday">1pm - 2pm</strong><strong v-else>10.30am - 2.30pm</strong> on your chosen day from the bakery at <a class="text-jblue whitespace-no-wrap border-b border-dotted border-jblue hover:text-jpink hover:border-solid hover:border-jpink" href="https://goo.gl/maps/yxUz2z2QRgpZiCjc6" target="_blank">129 Bloomfield Avenue, Belfast</a>
        <template v-if="!special"><br/><br/>You can order up to 6 weeks in advance.</template>
         </p>
      </div>


    </div> 

    <div v-if="christmasEve" class="p-2 my-4 bg-jpink text-white">
      Please note the bakery will close at 1pm on Christmas Eve
    </div>


    <div class="flex justify-between items-center mb-4" :class="{error: invalidTel}">
      <label class="text-sm w-1/3 m-0 text-left mr-2">Your phone number</label>
      <div class="flex-1">
        <input type="tel" class="input text-left" @change="dirty.telephone = true" v-model="order.telephone" />
        <p class="text-jpink text-sm mt-1" v-if="invalidTel">Please enter a valid telephone number</p>
      </div>
    </div>
    
    
    <div class="flex justify-between items-center mb-8" v-if="!special">
      <label class="text-sm w-1/3 m-0 text-left mr-2">Any additional instructions?</label>
      <div class="flex-1"><textarea class="input text-left" v-model="order.instructions" rows="3" cols="50" maxlength="300"></textarea>
      </div>
    </div>
    <div class="mb-8" v-if="false">
      <label class="text-sm text-left mr-2">
        <input type="checkbox" v-model="order.mailinglist">
        I'd like to join the J-bird mailing list
      </label>
    </div>

    <button 
      @click.prevent="checkout"
      type="button" class="mt-4 block w-full p-4 text-lg 
        focus:outline-none
        font-bold font-proxima border border-solid uppercase"
      :class="{
        'bg-jblue text-white border-jblue ': valid && !loading,
        'bg-gray-500 text-black border-gray-500 opacity-50 ': !valid || loading
      }"
      ><template v-if="loading">Loading...</template><template v-else>Pay {{total | currency}} now</template></button>

    <Allergens />  

  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import dayjs from 'dayjs';
import { find, some, forEach, concat, compact } from 'lodash';
import dateChecker from '../../functions/utils/date-checker'
import Allergens from '../components/Allergens';
import lscache from 'lscache';
export default {
  props: {
    basket: {},
    total: {},
    special: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Datepicker,
    Allergens
  },
  data() {
    return {
      loading: false,
      allergens: false,
      blackoutDates: this.$root.$data.blackout.dates,
      cakeBlackoutDates: this.$root.$data.blackout.cakes,
      cupcakeBlackoutDates: this.$root.$data.blackout.cupcakes,
      specialActiveDates: [],
      order: {
        date: null,
        telephone: null,
        instructions: "",
      },
      dirty: {
        telephone: false,
        date: false
      },
    }
  },
  mounted() {
    if(localStorage.order) {
      let storageOrder = JSON.parse(localStorage.order)
      if(storageOrder) {
        this.order = storageOrder
      }
    }

    if(this.special) {
      this.blackoutDates = this.$root.$data.blackout.specialDates
      this.cakeBlackoutDates = this.$root.$data.blackout.specialCakes
      this.specialActiveDates = this.$root.$data.blackout.specialActiveDates
      this.cupcakeBlackoutDates = this.$root.$data.blackout.specialCakes
      this.order.instructions = ""
    }

    try {
      fetch('/.netlify/functions/get-dates',{ 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((res) => res.json())
        .then(json => {
          if(this.special) {
            this.blackoutDates = json.specialDates
            this.cakeBlackoutDates = json.specialCakes
            this.cupcakeBlackoutDates = json.specialCupcakes
            this.specialActiveDates = json.specialActiveDates
          } else {
            this.blackoutDates = json.dates
            this.cakeBlackoutDates = json.cakes
            this.cupcakeBlackoutDates = json.cupcakes
          }
        })
    } catch(e) {
      console.log(e)
    }

  },
  watch: {
    order: {
      handler() {
        if(this.order.telephone) {
          this.dirty.telephone = true
        }
        if(this.order.date) {
          this.dirty.date = true
        }
        localStorage.order = JSON.stringify(this.order)
      },
      deep: true
    },
  },
  methods: {
    showAllergens() {
      if(this.allergens) {
        this.allergens = false;
      } else {
        this.allergens = true;
        setTimeout(() => this.$scrollTo(document.getElementById('allergens'), 1000, {offset: -50}), 500)
      } 
    },
    async checkout() {

      this.dirty.telephone = true
      this.dirty.date = true

      if(!this.valid) {
        return
      }
      this.loading = true

      try {


        const dateResponse = await fetch('/.netlify/functions/check-date', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            date: this.order.date,
            cake: this.hasCake,
            cupcake: this.hasCupcake,
            special: this.special
          })
        }).then((res) => {
          if(res.ok) {
            return true
          } else {
            res.json().then((json) => {
              if(this.special) {
                this.blackoutDates = json.specialDates
                this.cakeBlackoutDates = json.specialCakes
                this.cupcakeBlackoutDates = json.specialCupcakes
                this.specialActiveDates = json.specialActiveDates
              } else {
                this.blackoutDates = json.dates
                this.cakeBlackoutDates = json.cakes
                this.cupcakeBlackoutDates = json.cupcakes
              }
            })
            return false
          }
        })

        if(!dateResponse) {
          this.loading = false
          return 
        }

        const response = await fetch('/.netlify/functions/create-checkout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            basket: this.basket,
            order: {
              ...this.order,
              date: dayjs(this.order.date).format('dddd, D MMM YYYY'),
            }
          }),
        }).then((res) => res.json());

        try {
          if(lscache.get('basket')) {
            const basket = lscache.get('basket')
            let items = []
            forEach(basket, (item) => {
              const product = this.$root.$data.products.find(p => p.sku == item.sku)
              let litem = {
                id: product.sku,
                name: product.name,
                price: product.amount,
                quantity: 1,
              };

              items.push(litem)
            })

            window.gtag('event', 'begin_checkout', {
              "items": items
            });
          }
        } catch(e) {
          console.log(e)
          
        }

        const stripe = window.Stripe(response.publishableKey);
        const { error } = await stripe.redirectToCheckout({
          sessionId: response.sessionId,
        });

        this.loading = false
        if (error) {
          alert("There was a problem - please try again.")
        }
      } catch(e) {
        this.loading = false
        alert("There was a problem - please try again.")
      }
    }
  },
  computed: {
    thursday() {
      return false
      // if(this.order && this.order.date) {
      //   if(
      //     dayjs(this.order.date).isSame(dayjs('2021-03-11'),'date')
      //   ) { 

      //     return false
      //   } else {
      //     return dayjs(this.order.date).toDate().getDay() == 4
      //   }

      // } else {
      //   return false
      // }
    },
    christmasEve() {
      return dayjs(this.order.date).isSame(dayjs('2021-12-24'),'date')
    },
    valid() {
      if(this.dirty.telephone && this.dirty.date) {
        if(this.invalidDate || this.invalidTel) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    invalidTel() {
      return this.dirty.telephone && this.order.telephone.length < 11
    },
    invalidDate() {
      return this.dirty.date && !this.validateDate
    },
    hasCake() {
      return find(this.basket, {cake: true}) ? true : false
    },
    hasCupcake() {
      return find(this.basket, {cupcake: true}) ? true : false
    },

    validateDate() {
      return dateChecker({
        blackoutDates: this.blackoutDates,
        cakes: this.cakeBlackoutDates,
        cupcakes: this.cupcakeBlackoutDates,
        specialActiveDates: this.specialActiveDates
      }, this.order.date, this.hasCake, this.hasCupcake, this.special)
    },

    disabledDates() {

      let baseDate = dayjs();

      if(this.hasCake) {
        baseDate = dayjs().add(1,'d')
      }
      if(baseDate.isBefore(dayjs('2020-05-30'))) {
        baseDate = dayjs('2020-05-30')
      }

      const hasCake = this.hasCake
      const hasCupcake = this.hasCupcake
      const blackoutDates = this.blackoutDates
      const cakeBlackoutDates = this.cakeBlackoutDates
      const cupcakeBlackoutDates = this.cupcakeBlackoutDates
      const specialActiveDates = this.specialActiveDates
      const special = this.special

      let out = {}

      if(special) {
        out = {
          customPredictor: function(date) {
            let d = dayjs(date)
            if(d.isBefore(baseDate)){
              return true
            }
            if (!some(specialActiveDates, o => dayjs(o.date).isSame(d,'d'))) {
              return true
            }

            let dates = blackoutDates
            if(hasCake) {
              dates = concat(dates,cakeBlackoutDates)
            }
            if(hasCupcake) {
              dates = concat(dates,cupcakeBlackoutDates)
            }
            dates = compact(dates)
            if(some(dates, o => dayjs(o.date).isSame(d,'day'))) {
              return true
            }
            return false
          }
        }
      } else {
        out = {
          days: [0,1],
          customPredictor: function(date) {

            let d = dayjs(date)
            // disables the date if it is a multiple of 5
            if(d.isBefore(baseDate)){
              return true
            }
            if(d.isAfter(dayjs().add(6,'week'))) {
              return true
            }

            if(d.day() < 4 && !d.isSame(dayjs('2022-06-29'),'day')) {
              return true
            }
            
            let dates = blackoutDates
            if(hasCake) {
              dates = concat(dates,cakeBlackoutDates)
            }
            if(hasCupcake) {
              dates = concat(dates,cupcakeBlackoutDates)
            }
            dates = compact(dates)
            if(some(dates, o => dayjs(o.date).isSame(d,'day'))) {
              return true
            }
          }
        }
      }

      return out

    },
  }

}
</script>

<style>
.allergens p {
  @apply mb-3 text-left;
}
</style>